import { useCallback, useState } from 'react';

import useCountdown from './useCountdown';

// Number of seconds before auto navigation
const DELAY = 10;

const useAutoNavigationToProduct = (
  productUrl: string | null | undefined,
  countdownActive: boolean,
) => {
  const [navigated, setNavigated] = useState(false);

  const navigate = useCallback(() => {
    if (!navigated && productUrl != null) {
      const targetWindow = window.top ?? window;
      targetWindow.location.href = productUrl;
      setNavigated(true);
    }
  }, [productUrl, navigated]);

  const timer = useCountdown(
    DELAY,
    0,
    countdownActive && productUrl != null,
    navigate,
  );

  return [timer, countdownActive && productUrl != null] as const;
};

export default useAutoNavigationToProduct;
